export enum HelpLinkFeatureFlagEnum {
    knowledgeHelpVideos = '^feature-flag-knowledge-help-videos$',
    publicationCatalog = '^feature-flag-publication-catalog$',
    reviewRealtime = '^feature-flag-review-realtime$',
    aiPostGenerationV2 = '^feature-flag-ai-post-generation-v2$',
    reviewsStatisticsFilters = '^feature-flag-reviews-statistics-filters$',
    googlePlaywrightReviewAbuse = '^feature-flag-google-playwright-review-abuse$',
    aiPhotoQuality = '^feature-flag-ai-photo-quality$',
    aiBrandMonitoring = '^feature-flag-ai-brand-monitoring$',
}
